import dayjs from "dayjs";
import {t} from "i18next";

export const textModal = (slot, selectedRows, slotStatus, calculateTotalPaidForLength) => {
    const totalPaidForLength = calculateTotalPaidForLength();

    if (slotStatus.status === 'transfer') {
        return t('common.forms.movePaymentModal.fullTransferConfirmation', {
            count: selectedRows.length,
            slotName: slot.name,
            date: dayjs(slot.start_date).format('DD.MM.YYYY'),
            time: `${dayjs(slot.start_time, 'HH:mm:ss').format('HH:mm')} - ${dayjs(slot.end_time, 'HH:mm:ss').format('HH:mm')}`
        });
    } else {
        return t('common.forms.movePaymentModal.partialTransferConfirmation', {
            availableSits: slot.available_sits,
            requiredSits: totalPaidForLength
        });
    }
}